<template>
  <div>
    <Card>
      <h2>
        详情<span
          :class="
            config.instStatusMap[detailData.instStatus]
              ? 'approvalStatusStyle'
              : ''
          "
          >{{ config.instStatusMap[detailData.instStatus] }}</span
        >
      </h2>
    </Card>
    <Card>
      <p class="approvalCodeStyle">审批编号：{{ detailData.applyNo }}</p>
      <h2>{{ detailData.title }}</h2>
      <v-form-render
        ref="vformrender"
        :form-json="renderJson"
        :form-data="formData"
        :option-data="optionData"
        :fileUploadObj="fileUploadObj"
        class="marginStyle"
        @fileDownClick="fileDownClick"
        @filePreviewClick="filePreviewClick"
      />
      <form-info
        ref="formInfo"
        class="marginStyle"
        @applyDepartmentChange="applyDepartmentChange"
        :dataForm="dataFormInfo"
        :applyDepartmentList="applyDepartmentList"
        :isShowEditReason="isShowEditReason"
        :isDisabledEditReason="isDisabledEditReason"
      />
    </Card>
    <Card v-show="!isDisableCopyer" class="coper">
      <p slot="title">添加抄送人</p>
      <!-- <carbon-copy /> -->
      <CopyerSetting
        ref="CopyerSetting"
        :dataConfig.sync="dataConfig"
        typeTitle="抄送人"
        :multiple="true"
        :isCopyerDepartmentHidden="isCopyerDepartmentHidden"
      />
    </Card>
    <div class="bottomButtonBox">
      <div
        style="display: inline-block;"
        v-for="(btn, index) in footerButtonArr"
        :key="index"
      >
        <Button
          v-if="btn.isShow"
          :type="btn.type"
          @click="btn.fun(btn.params)"
          :icon="btn.icon"
          style="margin:10px;"
        >
          {{ btn.message }}
        </Button>
      </div>
    </div>
    <Modal v-model="approvalFlag" :title="modalTitle" :mask-closable="false">
      <modal-two
        ref="modalTwo"
        v-if="['TransferAudit', 'AddAudit'].includes(modalType)"
        :canAddAuditSeq="canAddAuditSeq"
        :modalType="modalType"
        :multiple="modalTwoMultiple"
      />
      <modal-three
        ref="Rollback"
        v-else-if="modalType == 'Rollback'"
        :selRollbackNodeList="selRollbackNodeList"
      />
      <modal-one ref="modalOne" :approvalFlag="approvalFlag" v-else />
      <div slot="footer">
        <Button @click="approvalFlag = false">取消</Button>
        <Button type="success" @click="modalSubmitClick">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import formInfo from './template/formInfo.vue'; // 中间表单信息
import modalOne from './template/ModalOne.vue'; // 弹窗组件
import modalTwo from './template/ModalTwo.vue'; // 加签弹窗
import modalThree from './template/ModalThree.vue'; // 退回弹窗
import CopyerSetting from '../copyerSetting/coperSetting.vue'; // 抄送人
import {
  actionOpApi,
  instApplyDetailApi,
  checkFormValuUnique
} from '@/api/approvalTask';
import util from '@/assets/js/util';
import { config } from './config';
export default {
  components: {
    formInfo,
    // carbonCopy,
    modalOne,
    modalTwo,
    modalThree,
    CopyerSetting
  },
  computed: {
    hasFullscreen() {
      const { fullscreen = false } = this.$route.query;
      return fullscreen;
    }
  },
  data() {
    return {
      config,
      dataConfig: {
        userType: 0
      },
      renderJson: {},
      formData: {},
      optionData: {},
      approvalFlag: false,
      tplConfigId: '', // 模板id
      buttonAuth: {}, // 按钮权限
      selRollbackNodeList: [], // 退回列表
      applyDepartmentName: '', // 所在部门名称
      applyDepartmentList: [], // 部门名称列表
      canAddAuditSeq: false, // 加签是否有顺序
      dataFormInfo: {
        applyDepartmentId: '',
        auditNote: ''
      }, // 表单数据
      footerButtonArr: [
        {
          message: '打回',
          type: 'primary',
          fun: this.modalFlagClick,
          params: 'RollbackApply'
        },
        {
          message: '撤回',
          type: 'primary',
          fun: this.confirm,
          params: 'Recall'
        },
        {
          message: '撤销',
          type: 'primary',
          fun: this.confirm,
          params: 'Withdraw'
        },
        {
          message: '修改',
          type: 'primary',
          fun: this.ModifySubmit,
          params: 'Modify'
        },
        {
          message: '评论',
          type: 'primary',
          fun: this.modalFlagClick,
          params: 'Comment'
        },
        {
          message: '同意',
          type: 'success',
          fun: this.modalFlagClick,
          params: 'Agree'
        },
        {
          message: '拒绝',
          type: 'error',
          fun: this.modalFlagClick,
          params: 'Refuse'
        },
        {
          message: '加签',
          type: 'primary',
          fun: this.modalFlagClick,
          params: 'AddAudit'
        },
        {
          message: '转交',
          type: 'primary',
          fun: this.modalFlagClick,
          params: 'TransferAudit'
        },
        {
          message: '退回',
          type: 'primary',
          fun: this.modalFlagClick,
          params: 'Rollback'
        },
        {
          message: '重新提交',
          type: 'primary',
          fun: this.confirm,
          params: 'RollbackApplySubmit'
        },
        {
          message: '撤销修改',
          type: 'primary',
          fun: this.confirm,
          params: 'WithdrawModify'
        }
      ],
      modalTwoMultiple: false, // 加签和转交的弹框中抄送人是否可以多选，默认是不可以
      isShowEditReason: false, // 是否显示修改原因
      isDisabledEditReason: true, // 是否禁用修改原因
      isDisableCopyer: true, // 是否禁用抄送人模块
      isCopyerDepartmentHidden: false, // 是否隐藏抄送人的部门主管
      modalTitle: '', // 弹窗标题
      modalType: '', // 弹窗类型：打回-RollbackApply，撤回-Recall，撤销-Withdraw，修改-Modify，评论-Comment，同意-Agree，拒绝-Refuse，加签-AddAudit，转交-TransferAudit，退回-Rollback，撤销修改-WithdrawModify
      fileUploadObj: {
        uploadId: { key: 'bucketAppRelId', value: '' }, // 文件上传id
        hosts: `https://${process.env.VUE_APP_DFS_HOST}`, // 文件上传请求域名
        headers: { 'X-Token-91': `${JSON.parse(localStorage.userInfo).token}` }
      }
    };
  },
  props: {
    detailData: {
      // 数据
      type: Object,
      default: {}
    },
    instApplyId: String, // 实例的唯一标识
    detailDataChangeCount: Number
  },
  watch: {
    detailDataChangeCount(val) {
      this.formatData(this.detailData); // 返回数据处理
    }
  },
  methods: {
    async submitData(type) {
      const vformRender = this.$refs.vformrender;
      const taskData = await vformRender.getFormData(); // 获取动态表单数据
      const { userType } = this.$refs.CopyerSetting.dataConfig; // 获取抄送人类型
      const notifyUserIds = []; // 抄送人数据
      let notifyUserUiInfo;
      const summary = this.getSummary(taskData);
      // 如果是指定人员 || 指定部门 || 指定角色(因为这三个用的同一个数组里不同的key值，所以需要取里面一层的数据)
      if ([1, 2, 3].includes(userType)) {
        notifyUserUiInfo = JSON.stringify(
          this.$refs.CopyerSetting[config.CopyerObjMap[userType]][
            config.CopyerChildObjMap[userType]
          ]
        );
        this.$refs.CopyerSetting[config.CopyerObjMap[userType]][
          config.CopyerChildObjMap[userType]
        ].forEach(item => {
          const idName = userType == 2 ? 'relationId' : 'id';
          notifyUserIds.push(item[idName]);
        });
      } else {
        notifyUserUiInfo = JSON.stringify(
          this.$refs.CopyerSetting[config.CopyerObjMap[userType]]
        );
        notifyUserIds.push(
          this.$refs.CopyerSetting[config.CopyerObjMap[userType]]
        );
      }
      let data;
      await this.repeatValid(taskData).then(res => {
        if (res) {
          data = Object.assign(
            { taskData }, // 表单数据
            { notifyUserIds }, // 抄送人数据
            {
              summary,
              ...this.$refs['formInfo'].dataForm, // 标表单数据（所在部门）
              notifyUserType: userType, // 抄送类型
              applyDepartmentName: this.applyDepartmentName, // 所在部门的名称
              notifyUserUiInfo
            }
          );
        } else {
          this.$Message.error('表单内容重复，请检查');
        }
      });
      return data;
    },
    // 重复校验
    repeatValid(data) {
      return new Promise((resolve, reject) => {
        const keyValList = [];
        const { widgetList } = this.renderJson;
        if (
          widgetList &&
          widgetList instanceof Array &&
          widgetList.length > 0
        ) {
          widgetList.forEach(item => {
            if (
              (item.type != 'table' || item.type != 'grid') &&
              item.options.noAllowRepeat == true
            ) {
              const id = item.options.name;
              keyValList.push({ id, name: data[item.options.name] });
            }
          });
        }
        const params = {
          tplConfigId: this.tplConfigId,
          instApplyId: this.instApplyId,
          keyValList
        };
        checkFormValuUnique(params).then(res => {
          const { code, data } = res.data;
          if (code == 200 && data != true) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    // 二次确认弹框共用方法
    confirm(type) {
      // type类型见data中定义的modalType注释
      let flag = true;
      if (['EditSubmit'].includes(type)) {
        this.$refs.formInfo.submitValid(valid => {
          if (!valid) {
            flag = false;
          }
        });
      }
      if (type == 'Withdraw' && this.detailData.instStatus == 2) {
        // 如果审批已通过，点击撤销的二次弹窗提示语需要更改。
        config.objMaps[type].content = '审批已通过，撤销需要再次审核';
      }
      if (flag) {
        this.$Modal.confirm({
          title: config.objMaps[type].confirmTitle,
          content: config.objMaps[type].content,
          onOk: async () => {
            let data = {
              instApplyId: this.instApplyId, // 实例唯一标识
              actionType: config.objMaps[type].actionType // 节点操作类型
            };
            let jumpRoute = 'self';
            if (['EditSubmit', 'RollbackApplySubmit'].includes(type)) {
              // 如果是修改提交 | 重新提交
              const res = await this.submitData();
              if (!res) return;
              data = Object.assign(res, data);
              jumpRoute = 'successTransfer';
            }
            this.actionOp(data, jumpRoute);
          }
        });
      }
    },
    // 修改
    async ModifySubmit() {
      const data = {
        instApplyId: this.instApplyId, // 实例唯一标识
        actionType: '102' // 节点操作类型，修改是：102
      };
      if (this.detailData.instStatus == 2) {
        // 如果是审批通过的话
        this.isShowEditReason = true;
        this.isDisabledEditReason = false;
        this.isDisableCopyer = false; // 抄送人禁用关闭
        const vformRender = this.$refs.vformrender;
        vformRender.enableForm(); // 恢复编辑
        this.setDisableForm(this.detailData, 'edit');
        this.footerButtonArr.forEach(item => {
          if (item.params == 'Modify') {
            item.isShow = false;
          }
        });
        this.footerButtonArr.push({
          message: '修改提交',
          fun: this.confirm,
          params: 'EditSubmit',
          isShow: this.isShowEditReason
        });
      } else {
        // 否则就跳转到提交页去
        this.$Modal.confirm({
          title: '确定要发起修改吗',
          content: '修改审批中的审批单将会撤回当前审批单，再次发起审核',
          onOk: async () => {
            let path = '/launchApprovalDetail';
            const query = { mode: 'edit', id: this.instApplyId };
            if (this.hasFullscreen) {
              path = '/launchApprovalDetailMaximize';
              query.fullscreen = true;
            }
            this.$router.push({ path, query });
          }
        });
      }
    },
    // 弹窗共用方法
    modalFlagClick(type) {
      // type类型见data中定义的modalType注释
      this.modalType = type;
      this.modalTitle = config.objMaps[type].modalTitle;
      this.modalTwoMultiple = type == 'AddAudit';
      this.approvalFlag = true;
    },
    // 弹窗确定按钮
    async modalSubmitClick() {
      let formData;
      let jumpRoute = 'self'; // 接口请求成功以后跳转路径
      if (this.modalType == 'AddAudit') {
        // 如果是加签
        formData = this.$refs['modalTwo'].dataForm;
        const auditListUser = this.$refs['modalTwo'].$refs.CopyerSetting.list
          .person;
        formData.addAuditUserIds = [];
        auditListUser.forEach(item => {
          formData.addAuditUserIds.push(item.id);
        });
        if (formData.addAuditSeq == 1) {
          // 如果是前加签，跳转到审批任务列表
          jumpRoute = 'approvalTask';
        }
      } else if (this.modalType == 'TransferAudit') {
        // 如果是转交
        formData = this.$refs['modalTwo'].dataForm;
        const auditListUser = this.$refs['modalTwo'].$refs.CopyerSetting.list
          .person;
        if (auditListUser && auditListUser instanceof Array) {
          if (auditListUser.length == 1) {
            formData.transferUserId = auditListUser[0].id;
          } else {
            this.$Message.error('转交人员请选择一人');
            return false;
          }
        }
        jumpRoute = 'approvalTask'; // 跳转到审批任务列表
      } else if (['Agree', 'Refuse'].includes(this.modalType)) {
        // 如果是同意，拒绝
        formData = await this.submitData(this.modalType);
        if (!formData) return;
        formData.auditNote = this.$refs.modalOne.dataForm.auditNote || '';
      } else if (this.modalType == 'Rollback') {
        // 如果是退回
        formData = this.$refs['Rollback'].dataForm;
        jumpRoute = 'approvalTask'; // 跳转到审批任务列表
      } else {
        if (['RollbackApply'].includes(this.modalType)) {
          // 如果是打回，跳转到审批任务列表
          jumpRoute = 'approvalTask'; // 跳转到审批任务列表
        }
        formData = this.$refs.modalOne.dataForm;
      }
      const data = Object.assign(
        { ...formData },
        {
          instApplyId: this.instApplyId, // 实例唯一标识
          actionType: config.objMaps[this.modalType].actionType // 节点操作类型
        }
      );
      this.actionOp(data, jumpRoute);
    },
    // 审批api方法
    actionOp(data, jumpRoute) {
      // data数据，jumpRoute跳转路径：(self自己本身，approvalTask审批任务列表)
      actionOpApi(data).then(async res => {
        const { data, code } = res.data;
        if (code == 200) {
          this.$Message.success(data.msg || '操作成功');
          this.approvalFlag = false;
          if (jumpRoute && jumpRoute != 'self') {
            let jumpUrl =
              jumpRoute == 'successTransfer'
                ? `${jumpRoute}?instApplyId=${data}`
                : jumpRoute; // 如果是跳转中转页，带上接口返回来的id
            // 如果是 jumpRoute 是工作列表 并且是全屏的(从别的系统跳转过来的) 就跳转全屏的地址
            const query = {};
            if (this.hasFullscreen) {
              query.fullscreen = true;
              jumpUrl = 'approvalTaskMaximize';
            }
            this.$router.push({ path: `/${jumpUrl}`, query });
          } else {
            // 更新本页面数据
            this.$emit('updateDetailData');
          }
        }
      });
    },
    // 所在部门change
    applyDepartmentChange(applyDepartmentName) {
      this.applyDepartmentName = applyDepartmentName;
    },
    // 返回数据处理
    formatData(data) {
      this.setFormDataInfo(data);
      this.tplConfigId = data.tplConfigId;
      const {
        canAddAuditSeq = false,
        buttonAuth = {},
        applyDepartmentId = '', // 所在部门
        modifyReason = '', // 修改原因
        applyDepartmentName,
        notifyUserUiInfo = '[]',
        notifyUserIds,
        notifyUserType,
        selRollbackNodeList,
        bucketAppRelId
      } = data;
      this.fileUploadObj.uploadId.value = bucketAppRelId; // 文件上传用到的id
      this.buttonAuth = buttonAuth;
      if (buttonAuth.RollbackApplySubmit) {
        // 如果有重新提交按钮
        const notifyUserUiInfoData = JSON.parse(notifyUserUiInfo || '[]');
        this.dataConfig = {
          ...this.dataConfig,
          nodeUserList: notifyUserUiInfoData,
          nodeExecUsers: notifyUserIds,
          userType: notifyUserType
        };
      } else {
        this.dataConfig = {
          userType: 0
        };
      }
      const CopyerSettingDom = this.$refs.CopyerSetting;
      CopyerSettingDom.initData(this.dataConfig);
      this.canAddAuditSeq = canAddAuditSeq;
      this.footerButtonAuth(buttonAuth);
      this.isShowEditReason = !!modifyReason; // 如果有修改原因，就显示修改原因字段
      this.dataFormInfo = { applyDepartmentId, auditNote: modifyReason };
      this.applyDepartmentList = [
        {
          departmentRelId: applyDepartmentId,
          departmentName: applyDepartmentName
        }
      ]; // 之前用的下拉框，所以按照列表方式给所在部门
      this.applyDepartmentName = applyDepartmentName; // 所在部门名称
      this.selRollbackNodeList = selRollbackNodeList || []; // 回退列表
      if (buttonAuth.RollbackApplySubmit) {
        this.isDisableCopyer = false;
        this.isDisabledEditReason = false;
      } // 如果是打回重新提交状态，可以编辑抄送人，否则抄送人是否可以编辑不在此处做更改。因为还有审批人进入详情也可以编辑的情况。
    },
    // 获取摘要
    getSummary(formOrigData) {
      try {
        let str = '';
        const renderJsonArr = [];
        const renderJson = util.hardCopyJson(this.renderJson.widgetList);
        if (
          renderJson &&
          renderJson instanceof Array &&
          renderJson.length > 0
        ) {
          renderJson.forEach(item => {
            // 如果不是表格和栅格类型的
            if (!['table', 'grid'].includes(item.type)) {
              const { label, name } = item.options;
              renderJsonArr.push({ label, name, type: item.type });
            }
          });
        }
        // 如果表单为3个以上，就取前3个做摘要
        for (
          let i = 0;
          i < (renderJsonArr.length >= 3 ? 3 : renderJsonArr.length);
          i++
        ) {
          const { label, name, type } = renderJsonArr[i];
          str += `${label}:${formOrigData[name] ? formOrigData[name] : '--'};`;
        }
        return str;
      } catch (err) {
        alert('获取摘要失败');
      }
    },
    // 渲染表单数据
    async setFormDataInfo(data) {
      await this.setDisableForm(data, 'render'); // 先设置表单权限，然后在渲染表单
      this.$refs.vformrender.setFormJson(data.formDesignDef);
      this.$nextTick(() => {
        this.$refs.vformrender.setFormData(data.formCurrData);
      });
    },
    // 按钮是否展示
    footerButtonAuth(buttonAuth) {
      if (buttonAuth.Agree || buttonAuth.Refuse) {
        // 如果有同意或者拒绝的权限，就可以编辑抄送人
        this.isDisableCopyer = false;
        this.isCopyerDepartmentHidden = true;
      }
      // if (buttonAuth.Agree && !buttonAuth.Refuse) {
      //   // 如果有同意 & 没有拒绝按钮权限，说明是办理节点，将同意的按钮名改为提交
      //   this.footerButtonArr.forEach(item => {
      //     if (item.params == 'Agree') {
      //       item.message = '提交';
      //     }
      //   });
      // }
      if (!(buttonAuth.submit || buttonAuth.RollbackApplySubmit)) {
        // 如果没有提交 | 重新提交按钮，默认设置为禁止编辑
        const vformRender = this.$refs.vformrender;
        vformRender.disableForm(); // 禁止编辑
      }
      // 判断按钮是否展示
      Object.keys(buttonAuth).forEach(key => {
        this.footerButtonArr.forEach(item => {
          if (item.params == key) {
            item.isShow = buttonAuth[key];
          }
          if (item.params == 'Agree') {
            item.message =
              buttonAuth.Agree && !buttonAuth.Refuse ? '提交' : '同意';
          }
        });
      });
    },
    // 表单权限禁用设置
    setDisableForm(data, type) {
      // type: edit点击修改进行的表单权限，render详情渲染进行的表单权限
      try {
        const {
          formDesignDef,
          formOpAuthList,
          applyFormOpAuthList,
          buttonAuth,
          flowList
        } = data;
        const formAuthList =
          type == 'edit' ? applyFormOpAuthList : formOpAuthList;
        if (flowList && flowList instanceof Array && flowList.length > 0) {
          // 如果是撤销流程，表单全部禁用。 applyType（0：正常流程，1：修改流程，2：撤销流程）
          const { applyType } = flowList[flowList.length - 1];
          if (applyType == 2) {
            this.revokedisabledForm(formDesignDef);
            return;
          }
        }
        if (
          formDesignDef.widgetList &&
          formDesignDef.widgetList instanceof Array &&
          formDesignDef.widgetList.length > 0
        ) {
          formDesignDef.widgetList.forEach(item => {
            // 根据是不是发起人先设置默认值
            if (item.type == 'table') {
              item.rows.forEach(rowsItem => {
                rowsItem.cols.forEach(colsItem => {
                  colsItem.widgetList[0].options.disabled = !(
                    (buttonAuth && buttonAuth.RollbackApplySubmit) ||
                    type == 'edit'
                  ); // 有重新提交按钮 || 发起人审批通过时点击修改按钮
                  colsItem.widgetList[0].options.hidden = false;
                });
              });
            } else {
              item.options.disabled = !(
                (buttonAuth && buttonAuth.RollbackApplySubmit) ||
                type == 'edit'
              );
              item.options.hidden = false;
            }
            // 根据表单权限给的数据判断
            if (
              formAuthList &&
              formAuthList instanceof Array &&
              formAuthList.length > 0
            ) {
              formAuthList.forEach(ele => {
                if (item.type == 'table') {
                  item.rows.forEach(rowsItem => {
                    rowsItem.cols.forEach(colsItem => {
                      // colsItem.widgetList[0].options.disabled = !(buttonAuth && buttonAuth.RollbackApplySubmit);
                      // colsItem.widgetList[0].options.hidden = false;
                      if (
                        colsItem.widgetList[0].options.name ==
                          ele.formItemKey &&
                        ele.formOpAuthType
                      ) {
                        const widgetListOption = colsItem.widgetList[0].options;
                        if (ele.formOpAuthType == 1) {
                          widgetListOption.disabled = false;
                        } else if (ele.formOpAuthType == 2) {
                          widgetListOption.disabled = true;
                        } else if (ele.formOpAuthType == 3) {
                          widgetListOption.hidden = true;
                        }
                      }
                    });
                  });
                } else {
                  // item.options.disabled = !(buttonAuth && buttonAuth.RollbackApplySubmit);
                  // item.options.hidden = false;
                  if (
                    item.options.name == ele.formItemKey &&
                    ele.formOpAuthType
                  ) {
                    if (ele.formOpAuthType == 1) {
                      item.options.disabled = false;
                    } else if (ele.formOpAuthType == 2) {
                      item.options.disabled = true;
                    } else if (ele.formOpAuthType == 3) {
                      item.options.hidden = true;
                    }
                  }
                }
              });
            }
          });
        }
      } catch (err) {
        alert('表单权限配置失败');
      }
    },
    // 撤销流程时表单禁用
    revokedisabledForm(data) {
      if (
        data.widgetList &&
        data.widgetList instanceof Array &&
        data.widgetList.length > 0
      ) {
        data.widgetList.forEach(item => {
          if (item.type == 'table') {
            item.rows.forEach(rowsItem => {
              rowsItem.cols.forEach(colsItem => {
                colsItem.widgetList[0].options.disabled = true;
              });
            });
          } else {
            item.options.disabled = true;
          }
        });
      }
    },
    fileDownClick(file) {
      util.fileDownloadBydomanType({
        ajax: this.$ajax,
        url: `/v1/dfs/down/${file.response.data}`,
        domainType: 'dfsApi',
        method: 'get',
        fileName: file.name
      });
    },
    filePreviewClick(file) {
      this.$ajax
        .get(`/v1/dfs/preview/${file.response.data}`, { domainType: 'dfsApi' })
        .then(res => {
          const { data } = res.data;
          window.open(data);
        });
    }
  },
  mounted() {
    this.formatData(this.detailData); // 返回数据处理
  }
};
</script>

<style scoped>
.approvalCodeStyle {
  color: #aaa;
  margin-bottom: 5px;
  font-size: 14px;
}
.marginStyle {
  margin-top: 18px;
}
.bottomButtonBox {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: #ddd;
  z-index: 999;
}
.approvalStatusStyle {
  color: #c93915;
  border: 2px solid #c93915;
  border-radius: 4px;
  padding: 4px;
  float: right;
}
.coper {
  margin-bottom: 52px;
}
</style>
